export { Tabs, Tab } from './Tabs';
